import { useNavigate } from "react-router-dom";

// legion
import { Text, Flex, Box, Button, Tooltip } from "@legion-ui/core";

const URLS = [
  {
    url: "/login/mobile-number",
    text: "Mobile Number as Primary Key",
  },
  {
    url: "/login/email-address",
    text: "Email Address as Primary Key",
  },
  {
    url: "/login/username",
    text: "Username / Email as Primary Key",
  },
  {
    url: "/login/nik",
    text: "Telkom NIK as Primary Key",
  },
  {
    url: "/login/sso",
    text: "Email with SSO as Primary Key",
  },
];

export const Landing = () => {
  const navigate = useNavigate();

  return (
    <Flex
      direction="column"
      width="100%"
      height="100%"
      alignY="center"
      alignX="center"
      background="#F5F8FF"
      padding={["0 2rem", "1rem"]}
    >
      <Box
        width="100%"
        background="white"
        radius="1rem"
        padding={["5rem 8.5rem", "3rem 2rem", "2rem 1rem"]}
        style={{
          maxWidth: "45.9375rem",
          height: "min-content",
        }}
      >
        <Box padding="0" style={{ height: "min-content" }}>
          <Text as="h3" size="2.25rem" weight="700" margin="0 0 0.75rem 0">
            Pattern Login and Register
          </Text>
          <Text as="p" size="1rem" weight="400" margin="0 0 1.5rem 0">
            Select pattern base on primary key with click the button bellow
          </Text>
        </Box>

        <Flex
          direction="column"
          padding="0"
          style={{ rowGap: "1.5rem", height: "min-content" }}
        >
          {URLS.map((URL) => (
            <>
              {URL.url && (
                <Button
                  variant="soft"
                  center={true}
                  disabled={!URL.url}
                  onClick={() => navigate(URL.url)}
                >
                  {URL.text}
                </Button>
              )}

              {!URL.url && (
                <Tooltip text="Upcoming">
                  <Button
                    variant="soft"
                    center={true}
                    disabled={!URL.url}
                    onClick={() => navigate(URL.url)}
                    block
                  >
                    {URL.text}
                  </Button>
                </Tooltip>
              )}
            </>
          ))}
        </Flex>
      </Box>
    </Flex>
  );
};
